module.exports = __webpack_public_path__ + "img/flow2.31182c13.png";